/* RJ Atelier builder - part 1: render engine. Fixed mm scale tied to real piece size (bracelet/nazariya = 5in). */
(function(){
'use strict';
var C = window.RJAT; if(!C) return;
var K=0.085;            /* detail-view px per mm per fs unit */
var CAP=0.70;           /* cap-height / font-size for the script face */
var NPM=K/CAP;          /* detail name font-size = fs*NPM*mm */
var GAPMM=0.8;          /* spacing between elements, mm */
var NTRIM=0.88;         /* trims script side-bearing so motifs sit close to the name */
var AR={eye_blue:1.0,eye_pink:1.0,eye_ring:1.0,crown_gold:1.125,crown_pink:1.125,crown_cz:1.0,heart_red:1.0,heart_blue:1.0,heart_pink:1.0,flower_pink:1.0,flower_purple:1.0,flower_cz:1.0,rainbow:1.1,star:1.0,basketball:1.0,football:1.0,car_blue:1.8571,car_red:1.4286,car_pink:1.1111,airplane:1.75,unicorn:0.8,butterfly_pink:1.125,butterfly:1.25,lion2:1.0,tiger:1.0,panda:1.0,bunny:1.0,giraffe:0.6154,elephant:1.3};
var SZ={eye_blue:0.6,eye_pink:0.6,eye_ring:0.9,crown_gold:0.8,crown_pink:0.8,crown_cz:1.0,heart_red:0.7,heart_blue:0.7,heart_pink:0.7,flower_pink:0.8,flower_purple:0.8,flower_cz:0.8,rainbow:1.0,star:0.9,basketball:1.0,football:1.0,car_blue:0.7,car_red:0.7,car_pink:0.9,airplane:0.8,unicorn:1.0,butterfly_pink:0.8,butterfly:0.8,lion2:1.0,tiger:1.0,panda:1.0,bunny:1.2,giraffe:1.3,elephant:1.0};
var VB={bracelet:{w:1000,h:955,cx:501,cy:456,R:482,bw:44,chordMax:0.85,ppm:23.85,qb:725},nazariya:{w:1000,h:1020,cx:505,cy:515,R:470,bw:64,chordMax:0.85,ppm:23.25,qb:770},bangle:{w:1000,h:404,cx:503,cy:-861,R:1232,amax:0.295,ppm:15}};
var CHAIN={bracelet:{cls:'cg',h:K*2,min:8},nazariya:{cls:'cb',h:K*2,min:8},bangle:{cls:'cband',h:K*3,min:12}};
var baseURI=null;
var root=document.getElementById('rj-atelier');
var piece=root.querySelector('#rjat-piece');

function nmCapMM(nm){
  var len=(nm||'').length||1;
  var hi=7, lo=5;            /* 5-7mm letter height for all metals (short name taller, long name shorter) */
  var t=Math.max(0,Math.min(1,(len-4)/5));
  return hi-t*(hi-lo);
}

function loadBase(cb){
  if(!C.baseURL){root.classList.remove('rjat-loading');cb&&cb();return;}
  baseURI=C.baseURL;
  root.classList.remove('rjat-loading');
  cb&&cb();
}

function probeW(fsize, name, font){
  var p=document.createElement('span');
  p.className='rjat-nm f-'+font;
  p.style.cssText='position:absolute;visibility:hidden;font-size:'+fsize+'px;-webkit-text-stroke:0';
  p.textContent=name||'';
  document.body.appendChild(p);
  var w=p.offsetWidth; document.body.removeChild(p); return w;
}

function renderDetail(st){
  var cfg=CHAIN[C.piece]||CHAIN.bracelet;
  var nMM=nmCapMM(st.name);
  var stageW=piece.parentElement.clientWidth-26;
  var fs=64;
  function calcW(f){
    var nf=f*NPM*nMM;
    var total=(st.name?probeW(nf,st.name,st.font)*1.06:0)+f*GAPMM*K+56;
    st.slots.forEach(function(m){ if(m) total+=AR[m]*(f*0.85*SZ[m])+f*GAPMM*K; });
    return total;
  }
  while(fs>20&&calcW(fs)>stageW)fs-=2;
  var cw=calcW(fs);
  if(cw>stageW)fs=Math.max(12,fs*stageW/cw);
  var nf=fs*NPM*nMM;
  var ringS=Math.max(5,Math.round(fs*K*2.2)),ringB=Math.max(2,Math.round(fs*K*0.7));
  var chainH=Math.max(cfg.min,Math.round(fs*cfg.h));
  function ring(){return '<span class="rjat-ring" style="width:'+ringS+'px;height:'+ringS+'px;border-width:'+ringB+'px;margin:0 2px"></span>';}
  function chain(side){return '<span class="rjat-chain '+cfg.cls+' '+side+'" style="height:'+chainH+'px;background-size:auto '+chainH+'px"></span>';}
  function mimg(m){return '<img class="rjat-motif" alt="" style="height:'+Math.round(fs*0.85*SZ[m])+'px" src="'+C.motifs[m]+'">';}
  var html=chain('l')+ring();
  if(st.slots[0]){html+=mimg(st.slots[0])+ring();}
  if(st.slots[1]){html+=mimg(st.slots[1])+ring();}
  if(st.name){html+='<span class="rjat-nm f-'+st.font+'" style="font-size:'+nf.toFixed(1)+'px">'+esc(st.name)+'</span>';}
  if(st.slots[2]){html+=ring()+mimg(st.slots[2]);}
  if(st.slots[3]){html+=ring()+mimg(st.slots[3]);}
  html+=ring()+chain('r');
  piece.innerHTML=html;
}

function seqOf(st){
  var seq=[];
  if(st.slots[0])seq.push({t:'m',k:st.slots[0]});
  if(st.slots[1])seq.push({t:'m',k:st.slots[1]});
  if(st.name)seq.push({t:'n'});
  if(st.slots[2])seq.push({t:'m',k:st.slots[2]});
  if(st.slots[3])seq.push({t:'m',k:st.slots[3]});
  return seq;
}

function mmList(st,seq,nMM){
  var nfMM=nMM/CAP;
  var wpf=st.name?probeW(100,st.name,st.font)/100:0;
  var ws=[], tot=0;
  seq.forEach(function(it,i){
    var w = it.t==='n' ? wpf*nfMM*NTRIM : AR[it.k]*SZ[it.k]*10;
    ws.push(w); tot+=w; if(i<seq.length-1)tot+=GAPMM;
  });
  return {ws:ws,tot:tot,nfMM:nfMM};
}

function renderFullChain(st){
  var B=VB[C.piece], R=B.R, seq=seqOf(st), nMM=nmCapMM(st.name);
  function shell(inner,defs){
    return '<div class="rjat-bwrap" style="width:min(72vw,330px)">'+
      '<svg class="rjat-full" viewBox="0 0 '+B.w+' '+B.h+'" style="aspect-ratio:'+B.w+'/'+B.h+'">'+
      '<defs>'+defs+'</defs>'+inner+'</svg></div>';
  }
  if(!baseURI){piece.innerHTML='<div class="rjat-wait"></div>';return;}
  if(!seq.length){
    piece.innerHTML=shell('<image class="rjat-bimg" href="'+baseURI+'" x="0" y="0" width="'+B.w+'" height="'+B.h+'"/>','');
    return;
  }
  var maxChord=2*R*B.chordMax;
  var L=mmList(st,seq,nMM);
  var PPM=B.ppm;
  if(L.tot*PPM>maxChord)PPM=maxChord/L.tot;
  var clusterPx=L.tot*PPM, gapPx=GAPMM*PPM;
  var half=clusterPx/2+PPM*1.5;
  var sinA=Math.min(half/R,0.985), aM=Math.asin(sinA);
  var qy=B.cy+R*Math.cos(aM);
  if(B.qb&&qy>B.qb)qy=B.qb;   /* small clusters: rest on the chain bottom, never float below it */
  var defs='<clipPath id="rjat-clip"><rect x="0" y="0" width="'+B.w+'" height="'+qy.toFixed(1)+'"/></clipPath>';
  var inner='<image class="rjat-bimg" href="'+baseURI+'" x="0" y="0" width="'+B.w+'" height="'+B.h+'" clip-path="url(#rjat-clip)"/>';
  var cur=-clusterPx/2;
  seq.forEach(function(it,i){
    var wPx=L.ws[i]*PPM, cXr=B.cx+cur+wPx/2;
    if(it.t==='n'){
      var nf=PPM*L.nfMM;
      inner+='<text class="f-'+st.font+'" font-size="'+nf.toFixed(1)+'" x="'+cXr.toFixed(1)+'" y="'+qy.toFixed(1)+'" text-anchor="middle" dominant-baseline="alphabetic" dy="'+(nf*0.2).toFixed(1)+'">'+esc(st.name)+'</text>';
    }else{
      var mh=PPM*SZ[it.k]*10, mw=AR[it.k]*mh;
      inner+='<image class="rjat-mimg" href="'+C.motifs[it.k]+'" x="'+(cXr-mw/2).toFixed(1)+'" y="'+(qy-mh*0.55).toFixed(1)+'" width="'+mw.toFixed(1)+'" height="'+mh.toFixed(1)+'"/>';
    }
    cur+=wPx+gapPx;
  });
  piece.innerHTML=shell(inner,defs);
}

function renderFullBangle(st){
  var B=VB.bangle, R=B.R, seq=seqOf(st), nMM=nmCapMM(st.name);
  function shell(inner,defs){
    return '<div class="rjat-bwrap" style="width:min(90vw,440px)">'+
      '<svg class="rjat-full" viewBox="0 0 '+B.w+' '+B.h+'" style="aspect-ratio:'+B.w+'/'+B.h+'">'+
      '<defs>'+defs+'</defs>'+inner+'</svg></div>';
  }
  if(!baseURI){piece.innerHTML='<div class="rjat-wait"></div>';return;}
  if(!seq.length){
    piece.innerHTML=shell('<image class="rjat-bimg" href="'+baseURI+'" x="0" y="0" width="'+B.w+'" height="'+B.h+'"/>','');
    return;
  }
  var usable=2*B.amax;
  var L=mmList(st,seq,nMM);
  var PPM=B.ppm;
  if((L.tot*PPM)/R>usable)PPM=usable*R/L.tot;
  var gapRad=(GAPMM*PPM)/R, clusterRad=(L.tot*PPM)/R;
  var p1x=B.cx+R*Math.sin(-B.amax), p1y=B.cy+R*Math.cos(-B.amax);
  var p2x=B.cx+R*Math.sin(B.amax),  p2y=B.cy+R*Math.cos(B.amax);
  var defs='<path id="rjat-arcP" d="M '+p1x.toFixed(1)+' '+p1y.toFixed(1)+' A '+R+' '+R+' 0 0 0 '+p2x.toFixed(1)+' '+p2y.toFixed(1)+'"/>';
  var inner='<image class="rjat-bimg" href="'+baseURI+'" x="0" y="0" width="'+B.w+'" height="'+B.h+'"/>';
  var cur=-clusterRad/2;
  seq.forEach(function(it,i){
    var wRad=(L.ws[i]*PPM)/R, cA=cur+wRad/2;
    if(it.t==='n'){
      var off=((cA+B.amax)/(2*B.amax))*100;
      inner+='<text class="f-'+st.font+'" font-size="'+(PPM*L.nfMM).toFixed(1)+'"><textPath href="#rjat-arcP" startOffset="'+off.toFixed(2)+'%" text-anchor="middle">'+esc(st.name)+'</textPath></text>';
    }else{
      var mh=PPM*SZ[it.k]*10, mw=AR[it.k]*mh;
      var mx=B.cx+R*Math.sin(cA), my=B.cy+R*Math.cos(cA);
      inner+='<image class="rjat-mimg" href="'+C.motifs[it.k]+'" x="'+(mx-mw/2).toFixed(1)+'" y="'+(my-mh*0.62).toFixed(1)+'" width="'+mw.toFixed(1)+'" height="'+mh.toFixed(1)+'"/>';
    }
    cur+=wRad+gapRad;
  });
  piece.innerHTML=shell(inner,defs);
}

function esc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}

window.RJATR={AR:AR,SZ:SZ,loadBase:loadBase,renderDetail:renderDetail,renderFullChain:renderFullChain,renderFullBangle:renderFullBangle,esc:esc};
})();
